import axios from 'axios';
import { VariantWithShade } from '../types/product';
import { shippingEstimate } from '../utils/shippingEstimate';
import { showOverlay } from '../components/overlay';
import '../components/CartWizard'

(function cart() {
  const selectors = {
    removeLineItem: '[data-remove-line-item]',
    removeLineItemData: 'removeLineItem',
    lineItems: '[data-variant-sku]',
    estimatedDelivery: '[data-estimated-delivery]',
    preOrderText: '[data-pre-order-text]',
    lineItemShade: '[data-line-item-shade]',
    shippingDisclaimer: '[data-shipping-disclaimer]',
    deleteLineItems: '[data-line-item-delete]',
  }


  const lineItemElements = document.querySelectorAll<HTMLLIElement>(selectors.lineItems);
 

  if (!lineItemElements) return

  const removeLineItems = document.querySelectorAll<HTMLElement>(selectors.removeLineItem)

  const lineItems: VariantWithShade[] = [];
  let lineItemsImagesArr = [];

  const handleVariantImages = () => {
    lineItemElements.forEach((lineItem: HTMLLIElement, index: any) => {
      const htmlImage = document.createElement('img');
      const imgElement = lineItem.querySelector('img');
      htmlImage.src = lineItemsImagesArr[index].data.image;

      imgElement.parentElement.prepend(htmlImage)
      imgElement.remove();
    });
  }

  async function getImage(variants: VariantWithShade[]) {
    const data = variants.map(({ sku, shade }) => {
      return axios.post('https://6eqmfkewa4.execute-api.us-east-1.amazonaws.com/image-provider-devel', {
        sku,
        model: shade,
      })
    });

    const response = await Promise.all(data);
    lineItemsImagesArr = response;

    handleVariantImages();
  }

  if (lineItemElements.length > 0) {
    lineItemElements.forEach((lineItem: HTMLLIElement) => {
      const id = parseInt(lineItem.dataset.variantId);
      const sku = lineItem.dataset.variantSku;
      const shade = lineItem.dataset.lineItemShade;
      lineItems.push({ sku, id, shade } as VariantWithShade);
    });
    getImage(lineItems);
    setShipping(lineItems, lineItemElements)
    // comment it out to fixed the can't remove the item error and there is no data-shipping-disclaimer
    // if (lineItemElements.length > 1) {
    //   document.querySelector(selectors.shippingDisclaimer).classList.remove('hidden')
    // }
  }

  function setShipping(lineItems: VariantWithShade[], lineItemElements: NodeListOf<HTMLLIElement>) {
    lineItems.forEach((item, index) => {
      const estimate = shippingEstimate(item)
      lineItemElements[index]
        .querySelectorAll(selectors.estimatedDelivery)
        .forEach(lineItem => {
          lineItem.innerHTML = estimate
          estimate === '14-18'
            ? lineItemElements[index].querySelector(selectors.preOrderText).classList.remove('hidden')
            : lineItemElements[index].querySelector(selectors.preOrderText).classList.add('hidden')
        })
    })
  }

  const showDeletePopup = () => {
    return `
      <div class="text-center fixed z-20 left-4 right-4 top-1/2 -translate-y-2/4 bg-white pt-12 px-4 pb-20 drop-shadow-cartItem max-w-[600px] mx-auto">
        <svg class="cursor-pointer absolute top-5 right-5" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" data-overlay-close>
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.509484 16.2458C0.314222 16.4411 0.314222 16.7577 0.509484 16.953C0.704746 17.1482 1.02133 17.1482 1.21659 16.953L8.99993 9.16961L16.7833 16.953C16.9785 17.1482 17.2951 17.1482 17.4904 16.953C17.6856 16.7577 17.6856 16.4411 17.4904 16.2458L9.70704 8.4625L16.7833 1.38627C16.9785 1.19101 16.9785 0.874424 16.7833 0.679162C16.588 0.4839 16.2714 0.4839 16.0762 0.679162L8.99993 7.7554L1.9237 0.679163C1.72844 0.483901 1.41185 0.483901 1.21659 0.679163C1.02133 0.874425 1.02133 1.19101 1.21659 1.38627L8.29283 8.4625L0.509484 16.2458Z"
            fill="black" />
        </svg>
        <h3 class="text-h3-m lg:text-h3-d lowercase first-letter:capitalize mb-8 mx-auto">Are you sure you want to delete this item from your cart?</h3>
        <p className="text-base-m lg:text-base-d mt-5 mx-auto">The changes you have made will be lost</p>

        <button class="text-btn-m lg:text-btn-d bg-black text-white px-2 py-4 w-full mt-16 max-w-[480px] mx-auto font-semibold uppercase" data-line-item-delete>Delete item</button>
        <button class="text-btn-m lg:text-btn-d underline !capitalize block mt-8 mx-auto" data-overlay-close>No</button>
      </div>
    `
  }

  const deleteLineItem = async (lineItem: any) => {
    document.querySelectorAll(selectors.deleteLineItems)
    .forEach((deleteLineItemButton) => {
      deleteLineItemButton.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: lineItem.dataset[selectors.removeLineItemData],
            quantity: 0,
          })
        })
        location.reload();
      });
    });
  }
  removeLineItems.forEach(lineItem =>
    lineItem.addEventListener('click', async () => {
      const htmlDiv = document.createElement('div');
      htmlDiv.innerHTML = showDeletePopup();
      document.body.append(htmlDiv);
      showOverlay(htmlDiv);
      deleteLineItem(lineItem);
    })
  )

})()
